import React, { useEffect, useState } from 'react';
import 'bootstrap/scss/bootstrap.scss';
import './App.scss';
import './css/spotip17an.scss';
import './css/songPlayer.scss';
import './css/songPlayerPC.scss';
import './css/songPlayerExpanded.scss';
import 'bootstrap/js/dist/collapse';
import './css/desktop.scss';

import { AppView } from "./components/view";
import useUserStore from './store/UserState';
import { createDB } from './utils/dbUtils';
import { Spotip17anFunctions } from './utils/api';
import { auth } from './firebase';
import { appThemes } from './components/view/spotipitan-content/app-customize/themes';
import { APP_VERSION } from './consts';

function App() {

  const { setOfflineMode } = useUserStore(state => state);
  const [loading, setLoading] = useState(true);
  const [loadingFirebase, setLoadingFirebase] = useState(true);

  useEffect(() => {
    createDB();

    // Comprobar si hay una versión más nueva en producción
    fetch(`/manifest.json?t=${Date.now()}`)
      .then(res => {
        if (res.ok) return res.json();
        throw new Error('Network response was not ok');
      })
      .then(data => {
        if (data && data.version && data.version !== APP_VERSION) {
          console.log(`New PWA version detected: ${data.version} (current: ${APP_VERSION}). Reloading...`);
          window.location.reload();
        }
      })
      .catch(err => console.warn('Could not check version:', err));
  }, []);

  const updateOnlineStatus = async () => {
    let ping;
    try {
      ping = await Spotip17anFunctions.use('ping', 5000).get();
    } catch (error) {
      console.error("no internet connection or not spotip17an server");
    }
    const hasInternetConnection = navigator.onLine && ping?.data === "pong";
    console.log("Online:", hasInternetConnection);

    if (!document.hidden || hasInternetConnection) {
      setOfflineMode(!hasInternetConnection);
    }
    setLoading(false);

    if (ping?.data !== "pong" && !document.hidden) {
      //retry in 5 seconds
      setTimeout(updateOnlineStatus, 5000);
    }
  };

  useEffect(() => {

    // Set initial value
    updateOnlineStatus();

    // Listen to changes
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        updateOnlineStatus();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    auth.onAuthStateChanged(() => {
      setLoadingFirebase(false);
    });
  }, []);



  useEffect(() => {
    const body = document.body;
    const themeId = localStorage.getItem("spotip17an-appTheme");
    const theme = appThemes.find(x => x.id === themeId) || appThemes[0];

    body.classList.remove(...appThemes.map(x => `theme-${x.id}`));
    body.classList.add(`theme-${theme.id}`);
    body.setAttribute("data-bs-theme", theme.dark ? "dark" : "light");

    requestAnimationFrame(() => {
      const themeColor = getComputedStyle(body).getPropertyValue('--bg-body').trim();
      if (themeColor) {
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) {
          meta.setAttribute('content', themeColor);
        }
      }
    });
  }, []);

  if (loading || loadingFirebase) {
    return (
      <div className="App" style={{ height: "100vh" }}>
        <div className="loading-screen d-flex justify-content-center align-items-center h-100">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="App">
      <AppView />
    </div>
  );
}

export default App;
